/**
 * An object URL for a blob, revoked when the blob changes or the component goes — the pattern
 * `QrPanel` follows by hand, for a blob that is already in hand (#160's photographs, kept in the
 * query cache).
 *
 * State set from the effect rather than a memo, because a memoised URL survives StrictMode's
 * unmount and remount while the effect's cleanup has already revoked it: the image would point at
 * nothing in development.
 */

import { useEffect, useState } from 'react'

export function useObjectUrl(blob: Blob | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!blob) {
      setUrl(null)
      return
    }
    const objectUrl = URL.createObjectURL(blob)
    setUrl(objectUrl)
    return () => URL.revokeObjectURL(objectUrl)
  }, [blob])

  return url
}
